import React, { useEffect } from "react";
import Banner from "../Components/AllBrands/Banner";
import Cards from "../Components/AllBrands/Cards";
import { usePagesBanners } from "../Context/PagesBannersContext";
import { useNavigate, useParams } from "react-router-dom";
import { useProducts } from "../Context/ProductsContext";

function AllBrands() {
  const { id } = useParams();
  const { isBanner } = usePagesBanners();
    const { getProductsSubBrands, isProductsSubBrands } = useProducts();
  const navigate = useNavigate();

  useEffect(() => {
    getProductsSubBrands(id);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [id]);

    if (isProductsSubBrands === null) {
    navigate(`/NotFound`, { replace: true }); // Redirect if there's no data
    return null; // Don't render anything while navigating
  }

  return (
    <div className="flex flex-col mx-[2rem] lg:mx-[7rem] md:mx-[4rem] items-center gap-7 overlay">
        <Banner isBanner={isBanner?.data[3]}/>
        <Cards isProductsSubBrands={isProductsSubBrands?.data} />
    </div>
  );
}

export default AllBrands;
